export default __webpack_public_path__ + "static/media/640_dummy2016-kosmetik01-de.de0638d0.png";